<!-- 首页跳转到校友消息通知页面 -->
<template>
  <div style="min-height: 100vh">
    <!-- 消息通知-我的消息 -->
    <div class="myNewsDiv" v-if="myNews.length != 0">
      <div class="unread">
        您有
        <div class="unreadTotal">{{ myNewsTotal }}</div>
        未读消息
      </div>

      <!-- 我的消息懒加载 -->
      <van-list
        :immediate-check="false"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="news clearfix" v-for="item in myNews" :key="item.id">
          <van-badge class="badgeBtn" dot v-if="item.isRead == 0"></van-badge>
          <div
            class="newsCard clearfix"
            v-if="item.type == 1"
            @click="gotoNewsDetail(item.id)"
          >
            <div class="newsImgDiv">
              <img
                src="../../assets/image/btn_xiaoxi_nor.png"
                alt="消息"
                class="newsImg"
              />
            </div>
            <div class="newsTitleAndTime">
              <div class="newsTitle">{{ item.content }}</div>
              <div class="newsTime">{{ getMyDate(item.creDate, true) }}</div>
            </div>
          </div>
          <!-- 已读消息跳转 -->
          <div
            class="newsDiv"
            v-else
            @click="gotoAlumniDetails(item.userId, item.isRead, item.id)"
          >
            <div class="newsImgDiv">
              <img
                src="../../assets/image/btn_jiaohuanmingpian_nor.png"
                alt="名片"
                class="newsImg"
              />
            </div>
            <div class="newsTitleAndTime">
              <div class="newsTitle">{{ item.content }}</div>
              <div class="newsTime">{{ getMyDate(item.creDate, true) }}</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>

    <div class="myNoDonation" v-else>
      <div class="noDonationDiv">
        <img
          src="../../assets/image/btn_nojuanzeng_nor.png"
          alt="图片"
          class="noDonation"
        />
      </div>
      <div class="tip">您还没有消息呦~</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      postMyNews: {
        page: 1,
        size:15,
      },
      userId: window.localStorage.getItem("user_id"),
      // userId: "43995354",
      activeNoticeTotal: "",
      myNewsTotal: "",
      activeNotice: [],
      myNews: [],
      myNewsDisplay: "",
      activeDisplay: "",
      loading: false,
      finished: false,
      myNewsLastPage: "",
      lastPage: 0,
    };
  },
  created() {
    this.getMyNews();
    this.myNewsDisplay = sessionStorage.getItem("myNewsDisplay");
    this.activeDisplay = sessionStorage.getItem("activeDisplay");
  },
  updated() {},
  methods: {
    async getMyNews() {
      const result = await this.$http.get("/myMsg/getMsg", {
        params: {
          userId: this.userId,
          page: this.postMyNews.page,
          size: this.postMyNews.size,
        },
      });
      for (let i = 0; i < result.data.list.length; i++) {
        this.myNews.push(result.data.list[i]);
        this.lastPage = result.data.lastPage;
      }
      console.log(this.myNews);
      this.myNewsTotal = result.data.num;
      this.myNewsLastPage = result.data.data.lastPage;
    },
    // gotoMyNews() {
    //   window.sessionStorage.setItem("myNewsDisplay", 2);
    //   window.sessionStorage.setItem("activeDisplay", 1);
    //   this.myNewsDisplay = sessionStorage.getItem("myNewsDisplay");
    //   this.activeDisplay = sessionStorage.getItem("activeDisplay");
    // },
    // gotoAlumnusActive() {
    //   window.sessionStorage.setItem("myNewsDisplay", 1);
    //   window.sessionStorage.setItem("activeDisplay", 2);
    //   this.myNewsDisplay = sessionStorage.getItem("myNewsDisplay");
    //   this.activeDisplay = sessionStorage.getItem("activeDisplay");
    // },


    // 未读消息跳转
    gotoNewsDetail(id) {
      console.log("未读id", id);
      return this.$router.push({ path: "/newsDetail", query: { mid: id } });
    },
    gotoAlumniDetails(userId, isRead, id) {
      console.log("已读userId, isRead", userId, isRead, id);
      return this.$router.push({
        path: "/alumniDetailNew",
        query: { alumniId: userId, mesId: id },
      });
    },
    // 我的消息懒加载
    onLoad() {
      this.postMyNews.page = this.postMyNews.page + 1;
      this.getMyNews();
      this.loading = false;
      // 数据全部加载完成
      if (this.postMyNews.page >= this.myNewsLastPage) {
        this.finished = true;
      }
    },

    // 参数 str 为时间戳 可以传入10位也可以传入13位
    // 参数 bool的值可传true或者false或者不传，如果需要显示秒则传true，不需要显示则传false或者不传
    getMyDate(str, bool) {
      if (str > 9999999999) {
        // 这里判断：时间戳为几位数
        var c_Date = new Date(parseInt(str));
      } else {
        var c_Date = new Date(parseInt(str) * 1000);
      }
      var c_Year = c_Date.getFullYear(),
        c_Month = c_Date.getMonth() + 1,
        c_Day = c_Date.getDate(),
        c_Hour = c_Date.getHours(),
        c_Min = c_Date.getMinutes(),
        c_Sen = c_Date.getSeconds();
      if (bool) {
        // 判断是否需要显示秒
        var c_Time =
          c_Year +
          "-" +
          this.getzf(c_Month) +
          "-" +
          this.getzf(c_Day) +
          " " +
          this.getzf(c_Hour) +
          ":" +
          this.getzf(c_Min) +
          ":" +
          this.getzf(c_Sen); //最后拼接时间
      } else {
        var c_Time =
          c_Year +
          "-" +
          this.getzf(c_Month) +
          "-" +
          this.getzf(c_Day) +
          " " +
          this.getzf(c_Hour) +
          ":" +
          this.getzf(c_Min); //最后拼接时间
      }
      return c_Time;
    },
    //补0操作  小于10的就在数字前面加0，这应该很好理解吧

    getzf(c_num) {
      if (parseInt(c_num) < 10) {
        c_num = "0" + c_num;
      }
      return c_num;
    },
    // 用法：
    // 需要显示秒：getMyDate(1523927510, true)
    // 不需要显示秒：① getMyDate(1523927510, false) ② getMyDate(1523927510)
    // 如果只需要时间： getMyDate(1523927510, true).split(" ")[1];
    // 如果只需要日期： getMyDate(1523927510, true).split(" ")[0];
  },
};
</script>
<style lang="less" scoped>
.active {
  background-color: #f5f5f5;
  position: relative;
}

.activeNav {
  position: relative;
  left: 5%;
  width: 90vw;
}

.alumnusActive {
  float: left;
  width: 50%;
  text-align: center;
  color: white;
  font-size: 1.3em;
  padding: 10px 0px 10px 0px;
  border-radius: 15px 0px 0px 15px;
}

.myNews {
  float: right;
  width: 50%;
  text-align: center;
  color: #999999;
  font-size: 1.3em;
  padding: 10px 0px 10px 0px;
  border-radius: 0px 15px 15px 0px;
}

.myNewsDiv {
  .van-list {
    height: 100%;
  }

  .unread {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: #000;
    font-size: 1rem;
    margin-top: 5px;
  }
  .unreadTotal {
    color: #00706e;
    font-size: 1.3rem;
    padding: 5px;
    font-weight: bold;
  }
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.activeNoticeDiv {
  margin-top: 20px;
  width: 90vw;
  position: relative;
  left: 5%;
}

.activeNoticeImg {
  width: 100%;
  height: 50vw;
  border-radius: 15px 15px 0px 0px;
}

.activeNoticeImgDiv {
  position: relative;
  box-sizing: border-box;
}

.activeNoticeStateAndPerson {
  position: absolute;
  bottom: 1%;
  width: 100%;
  background-color: #000000;
  opacity: 0.6;
}

.activeNoticeState {
  float: left;
  padding: 5px 0px 5px 10px;
  color: white;
}

.activeNoticePerson {
  float: right;
  padding: 5px 10px 5px 0px;
  color: white;
}

.activeNoticeIconDiv {
  float: right;
}

.activeNoticeIcon {
  width: 11vw;
  max-width: 50px;
  margin-left: 5px;
}

.activeNoticeDetail {
  width: 100%;
  height: 40vw;
  box-sizing: border-box;
  background-color: white;
  border-radius: 0px 0px 15px 15px;
}

.activeNotice {
  margin-bottom: 20px;
  border: 1px solid #e1e1e1;
  border-radius: 15px;
}

.activeNoticeDetailTitle {
  width: 100%;
  padding-top: 5px;
}

.activeNoticeType {
  color: #00706e;
  float: left;
  margin-right: 5px;
}

.activeNoticeTitle {
  margin-right: 5px;
}

.activeNoticeUnit,
.activeNoticeTime,
.activeNoticeAdress {
  padding-top: 5px;
  margin-left: 5px;
  color: #666666;
}

/* .activeNoticeTime {
  padding-top: 5px;
  color: #666666;
}
.activeNoticeAdress {
  padding-top: 5px;
  color: #666666;
} */

.badgeBtn {
  position: absolute;
  left: 11vw;
  top: 15%;
  width: 15px;
  height: 15px;
}

.news {
  position: relative;
  left: 2.5vw;
  width: 95vw;
  background-color: white;
  margin-top: 10px;
  border-radius: 15px;
  border: 1px solid #F2F2F2;
}

.newsImgDiv {
  float: left;
  width: 15vw;
  padding: 10px;
  // background: #999999;
}

.newsImg {
  // width: 100%;
  // height: 100%;
  object-fit: cover;
}

.newsTitleAndTime {
  // position: absolute;
  // left: 24%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // background: #f1cbcb;
;
}

.newsTitle {
  padding-top: 15px;
  float: left;
  // width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  color: #333333;
  font-size: 0.9rem;
  font-weight: 600;
}

.newsTime {
  padding-top: 12px;
  float: left;
  color: #999999;
  font-size: 0.9rem;
}

.starDiv {
  padding: 5px 0 10px 5px;
  color: #666666;
}

.starTitle {
  margin-top: 5px;
  float: left;
}

.starImgDiv {
  position: relative;
  float: left;
  margin: 0 5px;
  width: 9vw;
  height: 9vw;
  max-height: 60px;
  max-width: 60px;
}

.starImg {
  width: 100%;
  height: 100%;
  border-radius: 999px;
}

.iconDiv {
  position: absolute;
  left: 100%;
  top: 0;
  transform: translate(-70%, -30%);
  width: 4vw;
  max-width: 20px;
}

.iconImg {
  width: 100%;
}

.myNoDonation {
  height: 100vh;
}

.noDonationDiv {
  position: absolute;
  left: 50%;
  top: 10%;
  transform: translateX(-50%);
}

.noDonation {
  width: 100%;
}

.tip {
  position: absolute;
  left: 50%;
  top: 35%;
  transform: translateX(-50%);
  color: #969799;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/newsActive/AlumnusActive.vue